var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89.52 137.568",
    enableBackground: "new 0 0 89.52 137.568",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M87.499,64.782L8.405,1.189C5.024-1.529,0,0.878,0,5.216v127.186c0,4.339,5.024,6.746,8.405,4.027 l79.094-63.593C90.072,70.768,90.072,66.851,87.499,64.782z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFilled);
export default __webpack_public_path__ + "static/media/arrow_filled.17dbef538693e010e7d9671bce818f53.svg";
export { ForwardRef as ReactComponent };